import React, { useEffect } from 'react';

import { UseOutletContext } from '../main/Main';
import { StateLanguage } from '../../languages/config/StateLanguage';

import background from '../../assets/themes/images/error-page.svg';

export interface NotFoundMainPageProps {};

const NotFoundMainPage: React.FunctionComponent<NotFoundMainPageProps> = props => {
  const {setRoute} = UseOutletContext()
  const {lang} = StateLanguage()

  useEffect( () => {
    setRoute(null)
  })

  return (
    <div className="d-flex flex-column flex-column-fluid text-center p-10">
      <div className="mb-15">
        <h1 className="fs-3x text-capitalize mb-5">{lang.labels.pageNotFound}</h1>
        <div className="fw-bold fs-4 text-muted mb-10">
          {lang.labels.thePageYouLookedNotFound}
          <br />
          {lang.labels.pleaseCorrectThePathOfThePageInOrderToAccess}
        </div>
      </div>
      <div className="d-flex flex-row-auto bgi-no-repeat bgi-position-x-center bgi-size-contain bgi-position-y-bottom min-h-150px min-h-lg-200px" style={{backgroundImage: `url(${background})`}}></div>
    </div>
  )
};

export default NotFoundMainPage;
